(function () {
  function moneyFormatFromTheme(cents) {
    // fallback simples; seu tema pode ter formatação própria
    const value = (cents / 100).toFixed(2);
    return "$" + value;
  }

  function updateSticky(data) {
    const bar = document.querySelector("[data-sticky-atc]");
    if (!bar || !data || !data.variant) return;

    const variant = data.variant;

    const input = bar.querySelector("[data-sticky-atc-variant-id]");
    const priceEl = bar.querySelector("[data-sticky-atc-price]");
    const btn = bar.querySelector("[data-sticky-atc-button]");
    const btnText = bar.querySelector("[data-sticky-atc-btntext]");
    const img = bar.querySelector("[data-sticky-atc-image]");

    if (input) input.value = variant.id;

    const priceText = variant.price != null
      ? (window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(variant.price) : moneyFormatFromTheme(variant.price))
      : "";

    if (priceEl) priceEl.textContent = priceText;

    if (btn && btnText) {
      if (variant.available) {
        btn.disabled = false;
        btnText.textContent = `ADD TO CART – ${priceText}`;
      } else {
        btn.disabled = true;
        btnText.textContent = "SOLD OUT";
      }
    }

    // imagem (quando o tema envia featured_media)
    if (img) {
      const media = variant.featured_media || data.featured_media || null;
      if (media && media.preview_image && media.preview_image.src) {
        const src = media.preview_image.src.replace(/(\.jpg|\.jpeg|\.png|\.webp).*/i, "$1") + "?width=120";
        img.src = src;
      }
    }
  }

  // Dawn/OS2 costuma disparar esse evento
  document.addEventListener("variant:change", function (e) {
    updateSticky(e.detail);
  });

  // fallback: pega variant-id do form quando muda select
  document.addEventListener("change", function (e) {
    const bar = document.querySelector("[data-sticky-atc]");
    if (!bar) return;

    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (variantInput && (e.target.matches("select") || e.target.matches('input[type="radio"]'))) {
      bar.querySelector("[data-sticky-atc-variant-id]").value = variantInput.value;
    }
  });
})();
